import { render, staticRenderFns } from "./FollowPage.vue?vue&type=template&id=3d14492d&scoped=true"
import script from "./FollowPage.vue?vue&type=script&lang=js"
export * from "./FollowPage.vue?vue&type=script&lang=js"
import style0 from "./FollowPage.vue?vue&type=style&index=0&id=3d14492d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d14492d",
  null
  
)

export default component.exports